import { ReactNode } from 'react';

import {
  RatioProgressBar,
  Tooltip,
  Typography,
  Box,
  Stack,
} from '@cast/design-system';
import { normalizePercentage, toNumOrZero } from '@cast/utils';

const LABEL_MIN_WIDTH = 45;
const VALUE_MIN_WIDTH = 100;

type Props = {
  label: string;
  progressValue: number | null | undefined;
  progressColor: string;
  tooltipTitle?: string;
  primaryValue: ReactNode;
  secondaryValue?: ReactNode;
};

export const MetricRow = ({
  label,
  progressValue,
  progressColor,
  tooltipTitle,
  primaryValue,
  secondaryValue,
}: Props) => {
  const valueContent = (
    <Typography
      variant="P12R"
      component="span"
      sx={{ minWidth: VALUE_MIN_WIDTH, textAlign: 'right' }}
    >
      {primaryValue}
      {secondaryValue && (
        <Typography variant="P12R" color="textSecondary" component="span">
          {secondaryValue}
        </Typography>
      )}
    </Typography>
  );

  return (
    <Stack direction="row" gap={8} alignItems="center">
      <Box sx={{ minWidth: LABEL_MIN_WIDTH }}>
        <Typography variant="P12R">{label}</Typography>
      </Box>
      <Box flex={1}>
        <RatioProgressBar
          hideBorders
          size="lg"
          total={100}
          bars={[
            {
              value: normalizePercentage(toNumOrZero(progressValue)),
              color: progressColor,
            },
          ]}
        />
      </Box>
      {tooltipTitle ? (
        <Tooltip size="small" title={tooltipTitle} placement="top-start" arrow>
          {valueContent}
        </Tooltip>
      ) : (
        valueContent
      )}
    </Stack>
  );
};
